import { Link } from 'react-router-dom';

import { Alert } from 'components/v2/Alert/Alert';
import styled from 'styled-components';

export const AccountAlert = styled(Alert)`
  margin-bottom: 20px;
`;

export const AccountLink = styled(Link)`
  color: ${({ theme }) => theme.colors.blue.blue};
  font-weight: 700;
  text-decoration: underline;
`;
